import { useNavigate } from 'react-router-dom';

import PropTypes from 'prop-types';
import { BsClock } from 'react-icons/bs';

import AppBanner from '#globalComponents/AppBanner/AppBanner';
import { useAddonTrial } from '#lib/addons/useAddonTrial';
import { BILLING_SETTINGS_PATH } from '#lib/constants/routes';

const URGENT_DAYS = 3;

/**
 * Generic full-width top banner counting down an active add-on trial. Not dismissable —
 * a time-boxed countdown with a billing consequence. Shows only while a trial is active
 * (demo or add-on); hidden for paid/expired. Driven by an add-on config.
 */
const AddonTrialBanner = ({ addon }) => {
	const { isOnTrial, trialSource, daysRemaining } = useAddonTrial(addon.key);
	const navigate = useNavigate();

	if (!isOnTrial) return null;

	const urgent = daysRemaining !== null && daysRemaining <= URGENT_DAYS;

	const countdownText =
		daysRemaining === 0
			? `Ihre ${addon.name}-Testphase endet heute`
			: `Noch ${daysRemaining} ${daysRemaining === 1 ? 'Tag' : 'Tage'} ${addon.name}-Testphase`;

	const tail =
		trialSource === 'addon' ? ` – danach ${addon.priceShort}.` : ' – upgraden Sie für dauerhaften Zugriff.';
	const ctaLabel = trialSource === 'demo' ? 'Jetzt upgraden' : 'Test-Abo verwalten';

	return (
		<AppBanner
			tone={urgent ? 'caution' : 'accent'}
			icon={BsClock}
			action={{ label: ctaLabel, onClick: () => navigate(BILLING_SETTINGS_PATH) }}
		>
			<strong>{countdownText}</strong>
			{tail}
		</AppBanner>
	);
};

AddonTrialBanner.propTypes = {
	addon: PropTypes.shape({
		key: PropTypes.string.isRequired,
		name: PropTypes.string.isRequired,
		priceShort: PropTypes.string.isRequired,
	}).isRequired,
};

export default AddonTrialBanner;
